import * as React from 'react';
import _ from 'lodash';
import moment from 'moment';

import ProgressPanelItem from 'views/ucd/trident/common/ProgressPanelItem';
import {
  TRIDENT_CAMPAIGN_PROGRESS_PLACEHOLDER as CAMPAIGN_PROGRESS_PLACEHOLDER,
  TRIDENT_CAMPAIGN_TEMPLATE as CAMPAIGN_TEMPLATE,
  TRIDENT_CAMPAIGN_TEMPLATE_TYPES as CAMPAIGN_TEMPLATE_TYPES,
} from 'constants/ucd';
import { TridentCampaignFormData } from 'omega-rtc/types/ucd/campaign';
import { getSegmentUrl, getHedwigTemplateUrl } from 'views/trident-campaigns/review/campaign-analysis';
import { convertTridentActionToHedwigChannel } from 'data/trident-campaigns';


type Props = {
  onSectionSelected: Function, // Function to be triggered when user click the progress panel
  activeIndex: number,
  formData: TridentCampaignFormData,
  listRuleTypes: any,
  targetUserType: string
};


export class CreateCampaignProgressPanel extends React.Component {
  props: Props;

  getTemplateTypeDetails(formData: TridentCampaignFormData) {
    const templateType = _.get(formData, 'templateType', '');
    if (_.isEmpty(templateType)) {
      return [];
    }
    const selectedTemplate = _.find(CAMPAIGN_TEMPLATE_TYPES, { value: templateType });
    return [{
      name: 'Template',
      value: _.get(selectedTemplate, 'title', ''),
    }];
  }

  getEventDetails(formData: TridentCampaignFormData, listRuleTypes: any, targetUserType: string) {
    const eventType = _.get(formData, 'eventType', '');
    if (_.isEmpty(eventType)) {
      return [];
    }
    const eventTypeData = _.find(_.get(listRuleTypes, targetUserType), { eventType }); // e.g: {eventType:"onRideComplete", noun: "Ride Complete", ..."}
    const eventNoun = _.get(eventTypeData, 'noun', ''); // e.g: Ride Complete
    return [{
      name: 'Event',
      value: `(${eventNoun})`,
    }];
  }

  getEnumerationDetails(formData: TridentCampaignFormData, targetUserType: string) {
    const details = [];
    // Segment
    const segmentName = _.get(formData, 'segmentName');
    if (!_.isEmpty(segmentName)) {
      details.push({
        name: 'Segment',
        value: segmentName,
        url: getSegmentUrl(targetUserType, segmentName),
      });
    }
    // Template
    const templateID = _.get(formData, 'actions[0].meta.messagingPayload.templateID', '');
    if (!_.isEmpty(templateID)) {
      const templateType = convertTridentActionToHedwigChannel(_.get(formData, 'actions[0].type'));
      if (!_.isEmpty(templateType)) {
        details.push({
          name: 'Template',
          value: templateID,
          url: getHedwigTemplateUrl(templateType, templateID),
        });
      }
    }

    return details;
  }

  getScheduleTimeDetails(formData: TridentCampaignFormData) {
    const scheduleTime = _.get(formData, 'scheduleTime');
    if (_.isEmpty(scheduleTime)) {
      return [];
    }
    const momentTime = moment(scheduleTime);
    return [
      {
        name: 'Date',
        value: momentTime.format('DD MMM YYYY'),
      },
      {
        name: 'Time',
        value: momentTime.local().format('HH:mm [GMT]Z'),
      },
    ];
  }

  getProgressItem(panelPlaceholder: any, panelDetails: any[], index: number, clickable: boolean = true) {
    // panelPlaceholder fmt: {title: "...", text: "..."}
    // panelDetails fmt: {Name: "Template", Value: "Simple Schedule"}
    return (<ProgressPanelItem
      index={index}
      title={panelPlaceholder.title}
      activeIndex={this.props.activeIndex}
      placeholder={panelPlaceholder.text}
      details={panelDetails}
      onSectionSelected={this.props.onSectionSelected}
      targetUserType={this.props.targetUserType}
      clickable={clickable}
    />);
  }

  render() {
    const { formData, listRuleTypes, targetUserType } = this.props;
    const templateType = _.get(formData, 'templateType', '');
    const templateTypeDetails = this.getTemplateTypeDetails(formData);
    const eventDetails = this.getEventDetails(formData, listRuleTypes, targetUserType);

    // Schedule progress item building.
    const enumerationDetails = this.getEnumerationDetails(formData, targetUserType);

    const scheduleTimeDetails = this.getScheduleTimeDetails(formData);


    return (<React.Fragment>
      {this.getProgressItem(CAMPAIGN_PROGRESS_PLACEHOLDER.template, templateTypeDetails, 1)}

      {templateType === CAMPAIGN_TEMPLATE.simpleSchedule && <React.Fragment>
        {this.getProgressItem(CAMPAIGN_PROGRESS_PLACEHOLDER.enumeration, enumerationDetails, 2)}
        {this.getProgressItem(CAMPAIGN_PROGRESS_PLACEHOLDER.schedule, scheduleTimeDetails, 3)}
      </React.Fragment>
      }

      {templateType === CAMPAIGN_TEMPLATE.simpleScenario &&
        this.getProgressItem(CAMPAIGN_PROGRESS_PLACEHOLDER.scenario, eventDetails, 2)
      }

      {templateType === CAMPAIGN_TEMPLATE.multistepJourney && <React.Fragment>
        {this.getProgressItem(CAMPAIGN_PROGRESS_PLACEHOLDER.select_journey_template, enumerationDetails, 2)}
        {this.getProgressItem(CAMPAIGN_PROGRESS_PLACEHOLDER.customize_journey, scheduleTimeDetails, 3, false)}
        {this.getProgressItem(CAMPAIGN_PROGRESS_PLACEHOLDER.approval, scheduleTimeDetails, 4, false)}
      </React.Fragment>
      }
    </React.Fragment>);
  }
}
export default CreateCampaignProgressPanel;
